import { gql , TypedDocumentNode} from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { Appointment } from '../type/appointment'

export const GetAppointmentQuery: TypedDocumentNode<
  QueryPageableResponse<Appointment, 'appointmentsFind'>,
  QueryPageableRequest<{serviceTypeIds?: number[]}>
>= gql`
    query GetAppointmentQuery($request: AppointmentFindRequestInput!) {
        appointmentsFind(request: $request) {
            data {
                id
                createdAt
                firstName
                lastName
                email
                phone
                appointmentDate
                additionalInfo
                seen
                replied
                serviceTypeId
                serviceType
            }
            count
        }
    }
`

export const GetNewAppointmentCountQuery: TypedDocumentNode<{appointmentsNewCount: number}> = gql`
    query GetAppointmentCount{
        appointmentsNewCount
    }
`

export type AppointmentReportBucket = {bucket: string; count: number; isCurrent: boolean}
export type AppointmentReportSlice = {label: string | null; count: number}
export type AppointmentReport = {
  weekly: AppointmentReportBucket[]
  monthly: AppointmentReportBucket[]
  distribution: AppointmentReportSlice[]
}

export const GetAppointmentReportQuery: TypedDocumentNode<{appointmentReport: AppointmentReport}> = gql`
    query GetAppointmentReport {
        appointmentReport
    }
`

export const SetAppointmentAsSeenMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation SetAppointmentAsSeen($id: Int!) {
        appointmentSetAsSeen(id: $id)
    }
`

export const ToggleReplyAppointmentMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation ToggleReplyAppointment($id: Int!) {
        appointmentToggleReply(id: $id)
    }
`

export const SetAppointmentServiceTypeMutation: TypedDocumentNode<
  void,
  {id: number; serviceTypeId: number | null}
> = gql`
    mutation SetAppointmentServiceType($id: Int!, $serviceTypeId: Int) {
        appointmentSetServiceType(id: $id, serviceTypeId: $serviceTypeId)
    }
`

export const DeleteAppointmentMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation DeleteAppointment($id: Int!) {
        appointmentDelete(id: $id)
    }
`